var React = require('react');

function Chevron (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M1.692.29l3.906 3.906L9.504.29a.991.991 0 0 1 1.402 1.402L5.598 7 .29 1.692A.991.991 0 0 1 1.692.29z","fill":"#424242","fillRule":"evenodd"}));
}

Chevron.defaultProps = {"width":"12","height":"7","viewBox":"0 0 12 7"};

module.exports = Chevron;

Chevron.default = Chevron;
